import { useEffect } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';

import { useExperimentInfoActions } from '../../store/experimentInfoStore';
import { STATSIG_END_OF_TRIAL_EXPERIMENT, statsigCohorts } from '../../experimentConstants';

export const useLoadCohortToStore = () => {
	const { setCohort } = useExperimentInfoActions();
	const cohort = FeatureGates.getExperimentValue(
		STATSIG_END_OF_TRIAL_EXPERIMENT,
		'cohort',
		statsigCohorts.NON_ENROLLED,
		{
			fireExperimentExposure: false,
		},
	);

	useEffect(() => {
		void setCohort(cohort);
	}, [cohort, setCohort]);
};
